import {DataSnapshot, Unsubscribe, onValue, ref} from 'firebase/database';
import React from 'react';

import {useFirebaseDatabase} from './Firebase';

export const ShouldRefreshContext = React.createContext<boolean>(false);

type VersionUpdateMonitorProps = {
  children?: React.ReactNode;
};

/**
 * Monitors the version of the app in Firebase. If there's an update it
 * then updates the provider value for downstream components to use.
 */
const VersionUpdateMonitor: React.FunctionComponent<React.PropsWithChildren<{}>> = ({
  children,
}: VersionUpdateMonitorProps) => {
  const [shouldUpdate, setShouldUpdate] = React.useState<boolean>(false);
  const database = useFirebaseDatabase();
  const versionRef = React.useRef<number | undefined>(undefined);

  React.useEffect(() => {
    const realtimeVersionRef = ref(database, 'realtime/versions/hydroforecast');
    let unsubscribeListener: Unsubscribe;

    const handleVersionValue = (snapshot: DataSnapshot) => {
      const version: number = snapshot.val();
      if (versionRef.current === undefined) {
        versionRef.current = version;
      } else if (version > versionRef.current) {
        console.info(
          `New version is available. Previous version ${versionRef.current}. New version ${version}. Refreshing on next navigate.`
        );
        setShouldUpdate(true);
      }
    };

    unsubscribeListener = onValue(realtimeVersionRef, handleVersionValue);

    return () => {
      unsubscribeListener();
    };
  }, [database]);

  return (
    <ShouldRefreshContext.Provider value={shouldUpdate}>{children}</ShouldRefreshContext.Provider>
  );
};

export default VersionUpdateMonitor;
